import React from "react";
import { connect } from "react-redux";
import * as R from "ramda";

import { Div } from "components/Base";

import {
  getApplications,
  getSectionHeaderColor,
  getSectionHeaderFont,
  getSectionHeaderSize
} from "../selectors";
import { actions } from "Portal/PortalHome/model";

import CSSModules from "react-css-modules";
import css from "./styles.scss";

import StatusCircle from "ui-kit/StatusCircle";
import { H2, H3, TASK_ACTIONS } from "Portal/PortalHome/constants";
const decorate = R.compose(
  connect(
    state => ({
      applications: getApplications(state),
      sectionHeaderColor: getSectionHeaderColor(state),
      sectionHeaderFont: getSectionHeaderFont(state),
      sectionHeaderSize: getSectionHeaderSize(state)
    }),
    {
      executeAction: actions.executeAction
    }
  ),
  CSSModules(css)
);

const getIcon = type =>
  R.prop(type)({
    excel: (
      <Div width={25} height={25} ml={1}>
        <img
          alt="portal-icon-people"
          aria-label="portal-icon-people"
          src="https://d2dks4tzxs6xee.cloudfront.net/img/portal-icon-people.png"
          width="25"
          height="25"
        />
      </Div>
    ),
    word: (
      <Div width={25} height={25} ml={1}>
        <img
          alt="portal-icon-task"
          aria-label="portal-icon-task"
          src="https://d2dks4tzxs6xee.cloudfront.net/img/portal-icon-task.png"
          width="25"
          height="25"
        />
      </Div>
    ),
    pdf: (
      <Div width={30} height={30} ml={1}>
        <img
          alt="portal-icon-invoice"
          aria-label="portal-icon-invoice"
          src="https://d2dks4tzxs6xee.cloudfront.net/img/portal-icon-invoice.png"
          width="30"
          height="30"
        />
      </Div>
    )
  }) || (
    <Div width={26} height={26} ml={1}>
      <img
        alt="portal-icon-document"
        aria-label="portal-icon-document"
        src="https://d2dks4tzxs6xee.cloudfront.net/img/portal-icon-document.png"
        width="26"
        height="26"
      />
    </Div>
  );

export const Application = ({ type, executeAction, ...data }) => {
  const { status, name, open_label, due_label, is_past_due } = data;

  const icon = getIcon(type);

  return (
    <Div
      display="column"
      className={css.task__mobile}
      bg="white"
      px={3}
      py={3}
      bra={3}
      mb={3}
      shadow={{
        default: 0,
        hover: 2
      }}
      style={{
        cursor: "pointer",
        border: is_past_due ? "1px solid rgb(245, 159, 0)" : undefined
      }}
      onClick={() =>
        executeAction({ type: TASK_ACTIONS.OPEN_APPLICATION, data })
      }
    >
      <Div
        display="row.space-between.center"
        width={1}
        className={css.flex__wrap}
      >
        <Div display="row.flex-start.center" width={1}>
          {status === "rejected" ? (
            <StatusCircle status="rejected" size={30} />
          ) : status === "pending" ? (
            <StatusCircle status="pending" size={30} />
          ) : ["complete", "approved"].includes(status) ? (
            <StatusCircle status="approved" size={30} />
          ) : is_past_due ? (
            <StatusCircle status="not-submitted" size={30} />
          ) : (
            <StatusCircle status="default" size={30} />
          )}

          {icon}

          <Div fs={5} mr={2} fw={3} ml={icon ? 2 : 3} color="black">
            <H3
              style={{
                margin: "inherit",
                wordBreak: "break-word",
                fontSize: "22px"
              }}
            >
              {name}
            </H3>
          </Div>
        </Div>
        {open_label || due_label ? (
          <Div
            fs={2}
            ml={2}
            mr={2}
            color="black"
            display="row.flex-end.center"
            style={{
              flexShrink: 0
            }}
          >
            {[open_label, due_label].filter(v => v).join(" · ")}
          </Div>
        ) : null}
      </Div>
    </Div>
  );
};

const Applications = ({
  applications,
  executeAction,
  sectionHeaderColor,
  sectionHeaderFont,
  sectionHeaderSize
}) => {
  if (!applications.length) {
    return null;
  }

  return (
    <Div
      bg="#f2f2f2"
      style={{
        borderRadius: 10,
        padding: "10px 20px",
        marginBottom: "40px"
      }}
    >
      <Div display="row.flex-start.center" mb={4}>
        <Div
          className={css.tab}
          fw={4}
          style={{
            fontSize: "30px"
          }}
        >
          <H2
            style={{
              color: sectionHeaderColor,
              fontFamily: sectionHeaderFont,
              fontSize: sectionHeaderSize
            }}
          >
            My Application Submissions
          </H2>
        </Div>
      </Div>
      <Div className={css.application}>
        {applications.map(file => (
          <Application key={file.id} executeAction={executeAction} {...file} />
        ))}
      </Div>
    </Div>
  );
};

export default decorate(Applications);
